import React from "react";
import styles from "./styles/VisionMission.module.css";

export default function VisionMission() {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.block}>
          <h2 className={styles.heading}>Our Vision</h2>
          <p className={styles.text}>
            To be the market leader and trusted solutions provider in the design, distribution and implementation of industrial automation systems, robotics and special purpose machines.
          </p>
        </div>
        <div className={styles.block}>
          <h2 className={styles.heading}>Our Mission</h2>
          <p className={styles.text}>
            To continually improve and exceed customer expectations through high quality products and services, faster delivery, affordable cost, continuous innovation and reliable & quick after sales service. Achieve excellence by delivering the right automation and robotics solutions in association with our partners and customers.
          </p>
        </div>
      </div>
    </section>
  );
}
